interface Styles {
  iconTop?: number;
}

interface Config {
  iconPosition: string;
  styles?: Styles;
}

type ValidationMessage = {
  [key: string]: string;
};

export const validateConfig = (config: Config): false | ValidationMessage[] => {
  const validateMessage: ValidationMessage[] = [];
  const iconPositionArr = ['left', 'right'];

  if (!iconPositionArr.includes(config.iconPosition)) {
    validateMessage.push({
      iconPosition: "The icon position must be either 'left' or 'right'.",
    });
  }

  if (
    typeof config?.styles?.iconTop !== 'number' ||
    config?.styles?.iconTop < 0 ||
    config?.styles?.iconTop > 90
  ) {
    validateMessage.push({
      iconTop: 'iconTop must be a number between 1 and 90.',
    });
  }

  return validateMessage.length > 0 ? validateMessage : false;
};
